import styled from "styled-components";
import { theme } from "@themes";

export const ContentEditStyle = styled.div`
  display: grid;
  background-color: white;
  width: 41em;
  height: auto;
  padding: 1%;
  margin: 6% auto;
  grid-template-columns: 1fr;
  grid-template-rows: 40px 1fr 40px;
  grid-template-areas:
    "T"
    "C"
    "B";
`;
export const ContentTitleStyle = styled.div`
  grid-area: T;
  border-bottom: solid 1px #0000001f;

  p:nth-child(1) {
    float: left;
    margin: 0;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
  }
  p:nth-child(2) {
    float: right;
    font-size: large;
    font-weight: 600;
    margin: 0;
    cursor: pointer;
  }
`;
export const ContentCards = styled.div`
  grid-area: C;
  display: grid;
  grid-template-columns: auto auto;
  padding: 10px 12px;
  grid-gap: 0.5em;

  .grid-item {
    background-color: rgba(255, 255, 255, 0.8);
    border: solid 1px #0000001f;
    padding: 9px;
    font-size: 17px;
    text-align: center;
    border-radius: 4px;

    p {
      color: rgba(35, 35, 35, 1);
      text-transform: capitalize;
      font-size: 14px;
      font-weight: 600;
    }
    .SelectFont {
      width: 77%;
      height: 36px;
      font-size: 14px;
      margin-right: 0.6em;
    }
    select,
    input {
      border: #a5a0a0 solid 1px;
      border-radius: 3px;
      width: 19%;
      font-size: 14px;
      height: 36px;
    }
  }
`;

export const ContentSelect = styled.div`
  display: grid;
  grid-template-columns: 2.3em 2.3em 2.3em 2.3em 2em;
  grid-gap: 8px;
  margin-top: 7px;

  button {
    border: grey solid 1px;
    border-radius: 4px;
    font-size: 14px;
  }
  .colorPicker {
    width: 3em !important;
  }
`;
export const ColorPickerBackgorund = styled.input`
  height: 36px;
  margin-bottom: 1em;
`;

export const ContentSaveButton = styled.div`
  grid-area: B;
  border-top: solid 1px #0000001f;

  button {
    width: 9rem;
    height: 2rem;
    left: 1282px;
    top: 703px;
    background: ${({ theme }) => theme.button.primary};
    padding: 6px 12px;
    border-radius: 4px;
    border: none;
    float: right;
    color: white;
    margin-top: 8px;

    &:hover {
      box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.secondaryPurple};
      -webkit-transform: translateY(-1px);
      -ms-transform: translateY(-1px);
      transform: translateY(-1px);
      cursor: pointer;
    }
  }
`;

export const OptionWrapper = styled.div`
  display: grid;
  width: 10em;
  float: left;
  margin-top: 6px;
  grid-template-columns: 1em 1fr;
  align-items: center;
  padding-right: 1em;

  label {
    padding: 5px;
    text-align: left;
    margin: 0;
  }

  input {
    transform: scale(1.3);
  }

  input[type="checkbox"]:checked {
    background: ${({ theme }) => theme.button.primary};
    color: ${({ theme }) => theme.neutral.white};
  }

  span {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: black;
  }
`;
